import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ConsentType } from 'app/model/user/consent-model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UserService } from 'app/services/user/user.service';
import { Subscription } from 'rxjs/Subscription';
import { consentName } from 'environments/properties';

@Component({
  selector: 'act-service-and-privacy',
  templateUrl: './service-and-privacy.component.html',
  styleUrls: ['./service-and-privacy.component.scss']
})
export class ServiceAndPrivacyComponent implements OnInit, OnDestroy {
  public contentFromAPI: string;
  private getConsentDetailSubscription: Subscription;
  private langSubscription: Subscription;

  @Input() lang: string;
  @Input() content: string;
  @Input() isGetContentFromAPI = false;
  @Input() consentName = consentName;

  constructor(
    private appConfigService: AppConfigService,
    private userService: UserService
  ) {
    this.lang = appConfigService.getLanguage();
  }

  ngOnInit() {
    this.langSubscription && this.langSubscription.unsubscribe();
    this.langSubscription = this.appConfigService.getLanguageObs().subscribe(lang => {
      this.lang = lang;
      this.getConsentDetail(this.consentName, lang);
    });
    if (this.isGetContentFromAPI) {
      this.getConsentDetail(this.consentName, this.lang);
    }
  }

  ngOnDestroy() {
    this.langSubscription && this.langSubscription.unsubscribe();
    this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
  }

  getConsentDetail(consentName: string, lang: string) {
    this.getConsentDetailSubscription && this.getConsentDetailSubscription.unsubscribe();
    this.getConsentDetailSubscription = this.userService.getConsentDetail(consentName, ConsentType.PRIVACY, lang)
      .subscribe(
        res => {
          if (res) {
            this.contentFromAPI = res.privacy;
          }
        },
        err => console.error(err)
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/service-and-privacy/service-and-privacy.component.ts